import { selectors as brandSelectors } from "../brand";
// Named import user/selectors causes tests to break
import * as userSelectors from "../user/selectors";
import { actions as bridgeActions } from "../bridge";
import { FETCH_BRAND_SUCCESS } from "../brand/types";
import {
  GET_USER_SUCCESS,
  CREATE_USER_SUCCESS,
  MERGE_ACCOUNT_SUCCESS
} from "../user/types";
import { UPDATE_LICENSE_SUCCESS } from "../license/types";

// Middleware that will re-fetch bridge session when brand loaded
export default store => next => action => {
  next(action);
  /* 
        We need user info to have already been set, 
        so put this block after `next(action)`
      */
  if (
    [
      GET_USER_SUCCESS,
      CREATE_USER_SUCCESS,
      MERGE_ACCOUNT_SUCCESS,
      FETCH_BRAND_SUCCESS,
      UPDATE_LICENSE_SUCCESS
    ].indexOf(action.type) !== -1
  ) {
    const state = store.getState();
    const isAuthenticated = userSelectors.isAuthenticated(state);
    const bridgeEnabled = brandSelectors.getBrandValue(
      state,
      "Bridge.enabled",
      false
    );

    if (bridgeEnabled && isAuthenticated) {
      store.dispatch(bridgeActions.fetchSession(true));
    }
  }
};
